var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-sm mx-auto"},[_c('h2',{staticClass:"text-center mb-8"},[_vm._v("Notifications")])])
}]

export { render, staticRenderFns }